/** Elapsed time alone does not make a slow image request orphaned. */
export function scheduleRequestWatchdog(hasLiveRequest: () => boolean, clearOrphanedState: () => void) {
  return setTimeout(() => {
    if (!hasLiveRequest()) clearOrphanedState();
  }, 8 * 60 * 1000);
}
